import { ref, useContext } from "@nuxtjs/composition-api";
function addAllCategoriesLink(category, items = []) {
  const firstItem = {};
  if (!category.parent_id) {
    firstItem.id = category.id;
    firstItem.slug = category.slug;
  } else {
    const parentCat = category.branch[category.branch.length - 1];
    firstItem.id = parentCat.id;
    firstItem.slug = parentCat.slug;
  }
  return [firstItem, ...items];
}
function useCatalogNav() {
  const { $api } = useContext();
  const catalogNavItems = ref();
  const getCatalogNav = async (category) => {
    if (!category) {
      catalogNavItems.value = [];
    } else if (category.children?.length) {
      catalogNavItems.value = addAllCategoriesLink(category, category.children);
    } else {
      try {
        if (!category.parent_id) {
          catalogNavItems.value = [];
          return;
        }
        const { data } = await $api.categoriesService.getCategoryBySlug(
          category.parent_id.toString(),
          {
            includes: ["children"]
          }
        );
        catalogNavItems.value = addAllCategoriesLink(category, data.children);
      } catch (e) {
        console.error("Fetch category failed: ", e);
      }
    }
  };
  return { catalogNavItems, getCatalogNav };
}
var useCatalogNav_default = useCatalogNav;
export {
  useCatalogNav_default as default
};
